/* eslint-disable import/no-anonymous-default-export */
export default {
  serviceId: 'service_zdrjxm6',
  templateId: 'template_lln8g48',
  userId: 'Ra8omfhRPUtXR7Q8y',
};
